import styled from "styled-components";

// Submit button styling
export const PageButton = styled.button`
height:40px;
  width: 110px;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.primary};;
  color:#fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
 text-align: left;
  &:hover {
    background-color: #0056b3;
  }
`;